module.exports = __webpack_public_path__ + "static/media/mockup.42a4c178.png";